import React from 'react';
// Router imports
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import CaregiverDashboard from './pages/CaregiverDashboard';
import CaregiverJobs from './pages/CaregiverJobs';
import CustomerDashboard from './pages/CustomerDashboard';
import JobDetails from './pages/JobDetails';
import Profile from './pages/Profile';
import FindCaregivers from './pages/FindCaregivers';
import CaregiverProfile from './pages/CaregiverProfile';
import MyRequests from './pages/MyRequests';
import Wallet from './pages/Wallet/Wallet';
import NotFound from './pages/NotFound';
import LoadingScreen from './components/LoadingScreen';
import PrivateRoute from './components/PrivateRoute';
import MainLayout from './components/MainLayout';
import ScrollToTop from './components/ScrollToTop';

const AppRoutes: React.FC = () => {
  const { loading } = useAuth();
  
  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route element={<MainLayout />}>
            <Route 
              path="/caregiver/dashboard" 
              element={
                <PrivateRoute userType="caregiver">
                  <CaregiverDashboard />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/caregiver/jobs" 
              element={
                <PrivateRoute userType="caregiver">
                  <CaregiverJobs />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/customer/dashboard" 
              element={
                <PrivateRoute userType="customer">
                  <CustomerDashboard />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/jobs/:id" 
              element={
                <PrivateRoute>
                  <JobDetails />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/profile" 
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/customer/find-caregivers" 
              element={
                <PrivateRoute userType="customer">
                  <FindCaregivers />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/caregiver/:id" 
              element={
                <PrivateRoute userType="customer">
                  <CaregiverProfile />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/customer/my-requests" 
              element={
                <PrivateRoute userType="customer">
                  <MyRequests />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/wallet" 
              element={
                <PrivateRoute>
                  <Wallet />
                </PrivateRoute>
              } 
            />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AppRoutes />
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
